import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './SpecialAdverts.css';
import InlineAdvertsBlock from '../../../../components/InlineAdvertsBlock/InlineAdvertsBlock';

class SpecialAdverts extends React.Component {
  static propTypes = {
    cars: PropTypes.shape({
      vipCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      lowPriceCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      europeCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }).isRequired,
    specialLinks: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      tab: this.props.specialLinks[0].slug,
      isAllShown: false,
    };
  }

  setTab = tab => {
    this.setState({ tab, isAllShown: false });
  };

  getCurrentCars = tab => {
    const {
      cars: { vipCars, lowPriceCars, europeCars },
    } = this.props;

    switch (tab) {
      case 'top':
        return vipCars;
      case 'lowPrice':
        return lowPriceCars && lowPriceCars.length ? lowPriceCars : vipCars;
      case 'europe':
        return europeCars;
      default:
        return [];
    }
  };

  handleToggleShowClick = e => {
    e.preventDefault();
    this.setState(({ isAllShown }) => ({ isAllShown: !isAllShown }));
  };

  render() {
    const ITEMS_IN_LINE = 3;
    const DEFAULT_ROW_COUNT = 3;

    const { specialLinks } = this.props;
    const { tab, isAllShown } = this.state;

    const lensEvent = tab === 'top' ? 'bestCarsClick' : 'vipCarsClick';

    const cars = this.getCurrentCars(tab);
    const rowCount = isAllShown ? Math.ceil(cars.length / ITEMS_IN_LINE) : DEFAULT_ROW_COUNT;

    return (
      <div className={s.root}>
        <div className={s.navContainer}>
          <ul className={s.nav}>
            {specialLinks &&
              specialLinks.map(({ slug, title }) => (
                <li
                  key={slug}
                  className={tab === slug ? cx(s.tab, s.active) : s.tab}
                  onClick={() => this.setTab(slug)}
                >
                  <FormattedMessage id={title} />
                </li>
              ))}
          </ul>
        </div>
        <InlineAdvertsBlock
          items={cars}
          rows={rowCount}
          lensEvent={lensEvent}
          itemsInLine={ITEMS_IN_LINE}
        />
        <div className={s.showAll}>
          <div onClick={this.handleToggleShowClick} className={s.link}>
            <FormattedMessage id={isAllShown ? 'Скрыть' : 'Показать все'} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SpecialAdverts);



// WEBPACK FOOTER //
// ./src/desktop/routes/home/components/SpecialAdverts/SpecialAdverts.js